import { render, staticRenderFns } from "./Marche.vue?vue&type=template&id=c81b5d7c&"
import script from "./Marche.vue?vue&type=script&lang=js&"
export * from "./Marche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports